
<!-- muneeb teamlead view -->

<!-- teamlead view end -->

@if (showSpinner) {
  <app-loader> </app-loader>
}
<main class="content-wrapper">
  <div class="container-fluid mb-4">
    <!-- <div class="salary-input pb-3">

  </div> -->




  <div class=" mt-0">

    <div class="businessteam-section mt-4">
      <div class="heading-main py-2">
        <h1 class="">{{this.user_dep}}</h1>
      </div>
      <div class="employee-grid management-row">
        @for (user of teamLead; track user; let i = $index) {
          <div class="employee-card teamlead-card my-2"
            [style.background-image]="departmentBackgrounds[this.user_dep] ? 'url(' + departmentBackgrounds[this.user_dep] + ')' : ''">
            <div class="div" >
              <div class="image-titles d-flex justify-content-between">
                <div class="employee-year">
                </div>
                <div class="employee-year">
                  @if (user_role.role_type === 'Team_Lead' ) {
                    <img src="../../../assets/images/team lead.png" alt=""
                      >
                  }
                </div>
              </div>
              <div class="employee-profile text-center">
                <div class="profile-image">
                  <img src="{{user.profile_image }}" alt="image">
                </div>
                <h1 class="mt-2 mb-1">{{user.first_name}} {{user.last_name}}</h1>
                <h2>{{user.description}}</h2>
                <!-- <h2>{{ userRolesArray[departmentNames.indexOf(department)][i] }}</h2> -->
              </div>
              <div class="employee-info mt-2">
                <p><img src="../../../assets/images/mail.png" alt=""> {{user.email}}</p>
                <p><img src="../../../assets/images/clock.png" alt=""> 9am to 6pm</p>
                <div class="employee-eva">
                  <h1 class="pr-2">7</h1>
                  <p><span>EVALUATION</span><span>OUT</span><span>OF 10</span></p>
                </div>
                <!-- <div class="employee-info-footer">
                <h3>Allow WFH for Today:</h3>
                <input [checked]="user.attandance_type != 'Normal'" type="checkbox" (click)="childClick($event)"
                  (click)="toggleClick(user.id, $event)">
                </div> -->
              </div>
            </div>
            <div class="col-12 d-flex justify-content-between mt-3 flex-wrap">
              <!-- <button *ngIf="isavailablefeature('isDeleteUser')" (click)="deleteModal(user)"
              class="delete-btn text-center btn btn-light " type="submit" data-toggle="modal"
              data-target="#deleteModal">
              <div><i class="fa fa-trash-o"></i></div>
            </button> -->
            <!-- <div *ngIf="isavailablefeature('isUpdateUser')" class="edit-btn text-center float-right btn btn-light"
            data-toggle="modal" data-target="#quickEditModal" (click)="setUserUUID(user.uuid)">
            <div><i class="fa fa-edit"></i></div>
          </div> -->
          <!-- Button trigger modal -->
        </div>
        <div class="employee-card-footer text-center py-2">
          @for (footerImage of getFooterImages(this.user_dep); track footerImage) {
            <a >
              <img [src]="'../../../assets/images/' + footerImage" alt="">
            </a>
          }
        </div>
        <!-- bottom-border  -->
        <div class="yellow-label">
        </div>
        <div class="yellow-label-left">
        </div>
        <div class="yellow-label-right">
        </div>
      </div>
    }


  </div>

</div>


</div>


</div>


</main>